import Navbar from "./Components/Navbar/Navbar";
import Carousel1 from "./Components/Carousel/Carousel1";
import Aboutus from "./Components/AboutUs/Aboutus";
import "animate.css";
import "../src/Components/Styles/animated.css";
import "../src/Components/Styles/style.css";
import Team from "./Components/Team/Team";
import Gallery from "./Components/Gallery/Gallery";
import Video from "./Components/Video/Video";
import ContactUs from "./Components/ContactUs/ContactUs";
import Client from "./Components/Client/Client";
import Footer from "./Components/Footer/Footer";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Carousel1 />
      <Aboutus />
      <Team />
      <Gallery />
      <Video />
      <ContactUs />
      <Client />
      <Footer />
    </div>
  );
}

export default App;
